import { useEffect, useState } from 'react';
import { ReactComponent as CheckIcon } from '../../assets/check.svg';

import { Pane } from './pane';
import * as cn from 'classnames';
import { CollapsableContainer, CollapsableContainerHeader } from '../widgets/collapsable-container-header/collapsable-container-header';
import Collapsible from 'react-collapsible';
import { useOrganizations } from '../../contexts/organization-context';
import { Loading } from '../widgets/loading/loading';

export const OrganizationDetailPane = ({ ecosystemPhases = [], ecosystemActivities = [], visible }) => {
  const { organizationIds } = useOrganizations();
  const [organization, setOrganization] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const loadOrganization = async (organizationId) => {
    const result = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${organizationId}`);
    const orgData = await result.json();
    setOrganization(orgData);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    if (!visible || organizationIds.length === 0) {
      return;
    }
    loadOrganization(organizationIds[0]);
  }, [visible, organizationIds]);

  if (organizationIds.length === 0 || !organization) {
    return null;
  }

  const orgPhases = ecosystemPhases.filter((p) => organization?.phases?.some((op) => op.ID === p.ID));
  const orgActivities = ecosystemActivities.filter((a) => organization?.activities?.some((oa) => oa.ID === a.ID));

  return (
    <Pane visible={visible}>
      {isLoading && (
        <div className="loading-container">
          <Loading />
        </div>
      )}
      {!isLoading && (
        <>
          <div className="paneSection" style={{ marginTop: 8 }}>
            <Collapsible
              trigger={<CollapsableContainerHeader label="Ecosystem phases" />}
              easing="ease"
              transitionTime={100 + (orgPhases?.length || 0) * 25}
              open={true}
            >
              {orgPhases.map((p) => (
                <div className="text-normal" style={styles.odpListItem}>
                  <CheckIcon></CheckIcon>
                  <div>{p.NAME}</div>
                </div>
              ))}
            </Collapsible>
          </div>
          <div className="paneSection" style={{ marginTop: 8 }}>
            <Collapsible
              trigger={<CollapsableContainerHeader label="Activities" />}
              easing="ease"
              transitionTime={100 + (orgActivities?.length || 0) * 25}
              open={true}
            >
              {orgActivities.map((a) => (
                <div className="text-normal" style={styles.odpListItem}>
                  <CheckIcon></CheckIcon>
                  <div>{a.NAME}</div>
                </div>
              ))}
            </Collapsible>
          </div>
        </>
      )}
    </Pane>
  );
};

const styles = {
  odpListItem: {
    paddingTop: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
};
